import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type {
  ActivityIndexVo,
  ActivityStatusVo,
  ActivitySyncStatusVo,
  ActivityDrawVo,
  ParamsActivitySyncStatus,
  ActivityStatusV1Vo,
  ActivityInvitationCodeVo,
  ActivityAwardRecordVo,
  SnagVo,
  ActivityFreeCoinsIndexVo,
  ActivityGameRank,
  ActivityGameStart,
  ActivityGameFlip,
  FlipCardActivityDetailVo,
  ActivityDrawDTO,
  ActivityGamePassSubmitDTO,
  ActivityAwardRecordDTO
} from './types.ts';

/**
 * 获取活动信息
 */
export const getActivityIndex = (params?: {
  activityType: number;
}): AxiosPromise<ActivityIndexVo | ActivityFreeCoinsIndexVo | FlipCardActivityDetailVo> => {
  return request({
    url: '/member/activity/index',
    method: 'get',
    params
  });
};

/**
 * 同步会员状态
 */
export const getSyncStatus = (data: ParamsActivitySyncStatus): AxiosPromise<ActivitySyncStatusVo> => {
  return request({
    url: '/member/activity/syncStatus',
    method: 'post',
    data
  });
};
/**
 * 同步设置
 */
export const getSyncSet = (data: { eaAccount: string; platformId: number }): AxiosPromise<boolean> => {
  return request({
    url: '/member/activity/syncSet',
    method: 'post',
    data
  });
};
/*
 * 抽奖
 */
export const getDraw = (data: ActivityDrawDTO): AxiosPromise<ActivityDrawVo> => {
  return request({
    url: '/member/activity/draw',
    method: 'post',
    data
  });
};
/*
 * 获取活动状态
 */
export const getActivityStatus = (): AxiosPromise<ActivityStatusVo> => {
  return request({
    url: '/member/activity/status',
    method: 'get'
  });
};

/**
 * 完成活动任务
 */
export const postCompleteTask = (id: string): AxiosPromise<ActivityStatusVo> => {
  return request({
    url: '/member/activity/completeTask',
    method: 'post',
    data: { taskId: id }
  });
};

// 获取活动状态v1
// GET /member/activity/v1/status
// 接口ID：315922749
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-315922749
export const getActivityStatusV1 = (): AxiosPromise<ActivityStatusV1Vo> => {
  return request({
    url: '/member/activity/v1/status',
    method: 'get'
  });
};

/**
 * 获取拉新活动邀请码信息
 * /member/activity/invitationCode
 */
export const getInvitationCode = (invitationCode: string): AxiosPromise<ActivityInvitationCodeVo> => {
  return request({
    url: '/member/activity/invitationCode',
    method: 'post',
    data: { invitationCode }
  });
};
/**
 * 拉新活动领取奖励
 * /member/activity/acquireReceiveReward
 */
export const acquireReceiveReward = (platformId?: string): AxiosPromise<any> => {
  return request({
    url: '/member/activity/acquireReceiveReward',
    method: 'post',
    data: { platformId }
  });
};
/**
 * 获奖记录
 * /member/activity/awardRecord
 */
export const awardRecord = (data: {
  pageSize?: number;
  pageNum?: number;
  orderByColumn?: string;
  isAsc?: string;
  activityType?: number;
  currentFlag?: number;
  firstNum?: number;
}): AxiosPromise<ActivityAwardRecordVo[]> => {
  return request({
    url: '/member/activity/awardRecord',
    method: 'post',
    data
  });
};
/**
 * 免费金币活动 抢
 * /member/activity/snag
 */
export const freeCoinsSnag = (data: { scheduleId?: number }): AxiosPromise<SnagVo> => {
  return request({
    url: '/member/activity/snag',
    method: 'post',
    data
  });
};
/**
 * 免费金币活动 预选平台
 * /member/activity/preSelectPlatform
 */
export const freeCoinsPreSelectPlatform = (data: {
  eaAccount?: string;
  platformId?: string;
}): AxiosPromise<ActivityAwardRecordVo[]> => {
  return request({
    url: '/member/activity/preSelectPlatform',
    method: 'post',
    data
  });
};

// 排行榜信息
// GET /member/activity/game/rank

export const activityGameRank = (params: {
  rankType?: number;
  rankStatus?: number;
  scheduleId?: string;
}): AxiosPromise<ActivityGameRank> => {
  return request({
    url: '/member/activity/game/rank',
    method: 'get',
    params
  });
};

/**
 * 已读排行榜通知
 * /member/activity/game/rankRead
 */
export const activityGameRankRead = (): AxiosPromise<boolean> => {
  return request({
    url: '/member/activity/game/rankRead',
    method: 'post'
  });
};

/**
 * 开始游戏
 * /member/activity/game/start
 */
export const activityGameStart = (): AxiosPromise<ActivityGameStart> => {
  return request({
    url: '/member/activity/game/start',
    method: 'post'
  });
};

/**
 * 翻卡
 * /member/activity/game/flip
 */
export const activityGameFlip = (data: { position: number; roundLevelId?: string | number }): AxiosPromise<ActivityGameFlip> => {
  return request({
    url: '/member/activity/game/flip',
    method: 'post',
    data
  });
};

/**
 * 填写gamePass
 */
export const activityGamePassSubmit = (data: ActivityGamePassSubmitDTO): AxiosPromise<boolean> => {
  return request({
    url: '/member/activity/submitGamePass',
    method: 'post',
    data
  });
};

/**
 * 获奖记录
 */
export const activityAwardRecord = (data: ActivityAwardRecordDTO): AxiosPromise<ActivityAwardRecordVo[]> => {
  return request({
    url: '/member/activity/awardRecord',
    method: 'post',
    data
  });
};
